import { FacetItem, FacetListItem } from '@hermes/api-sdk'
import { useBookSearchFacet } from '@hermes/search'
import { Box, Button, List, ListItem, ListItemButton, ListItemText } from '@hermes/web-components'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { useAnalytics } from '@lib/contexts/analyticsContext'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import React, { useState } from 'react'
import Input from './TextField'

interface SearchFilterFacetProps extends FacetItem {
  title: string
  hasSearchField?: boolean
  shouldShowEmptyState?: boolean
  limit?: number
  sortBy?: 'count' | 'value'
}

export const SearchFilterFacet: React.FC<SearchFilterFacetProps> = ({
  title,
  hasSearchField = false,
  shouldShowEmptyState = true,
  attribute,
  transformItems,
  limit
}) => {
  const { t } = useTranslateMessage()
  const [search, setSearch] = useState('')
  const analytics = useAnalytics()
  const { toggleRefinement: refine, items } = useBookSearchFacet({ attribute, transformItems })

  const applySearch = (value: string) => {
    setSearch(value)
  }

  const toggleRefinement = (item: FacetListItem) => {
    if (item.isRefined) {
      analytics.trackEvent('SEARCH_REFINEMENT_REMOVED', {
        refinement: title
      })
    } else {
      analytics.trackEvent('SEARCH_REFINEMENT_ADDED', {
        refinement: title,
        refinementValue: item.value
      })
    }
    refine(item.value)
  }
  return (
    <>
      {hasSearchField && (
        <ListItem
          disableGutters
          onKeyDown={(event) => {
            if (event.code === 'Enter') {
              applySearch(search)
            }
          }}
        >
          <Input
            label={`${t({ id: 'search.facet.placeHolder', defaultMessage: 'Search in' })} ${title}...`}
            type="search"
            autoComplete="off"
            autoCorrect="off"
            value={search}
            onChange={(value) => {
              setSearch(value)
            }}
          />
          <Button onClick={() => applySearch(search)} sx={{ padding: 0, borderRadius: 2 }}>
            {t({ id: 'search' })}
          </Button>
        </ListItem>
      )}
      <Box paddingLeft={'16px'} paddingRight={'16px'}>
        <List sx={{ paddingTop: '0px' }}>
          {items.length === 0 && shouldShowEmptyState ? (
            <ListItemText primary={t({ id: 'search.noResultsFound' })} />
          ) : (
            items.slice(0, limit).map((item) => (
              <ListItemButton
                disableGutters
                key={item.value}
                onClick={() => {
                  toggleRefinement(item)
                }}
                selected={item.isRefined}
                sx={{
                  flex: 1,
                  '&.Mui-selected': {
                    bgcolor: 'transparent'
                  }
                }}
              >
                {item.isRefined ? (
                  <CheckBoxIcon sx={{ height: '18px', width: '18px' }} />
                ) : (
                  <CheckBoxOutlineBlankIcon sx={{ height: '18px', width: '18px' }} />
                )}
                <ListItemText
                  id={item.label}
                  disableTypography
                  primary={`${item.label} (${item.count.toLocaleString()})`}
                  sx={{ marginLeft: 0.5 }}
                />
              </ListItemButton>
            ))
          )}
        </List>
      </Box>
    </>
  )
}
